// Risk-free rate lookup — PSD §6.2, F3.5. Engine layer (framework-free).
// Static embedded US Treasury yield curve (no network fetch).
const TREASURY_CURVE = [
    { maturity: 0.25, yield: 0.042 },
    { maturity: 0.5, yield: 0.0435 },
    { maturity: 1, yield: 0.045 },
    { maturity: 2, yield: 0.044 },
    { maturity: 3, yield: 0.043 },
    { maturity: 5, yield: 0.0425 },
    { maturity: 7, yield: 0.0435 },
    { maturity: 10, yield: 0.0445 },
    { maturity: 20, yield: 0.0475 },
    { maturity: 30, yield: 0.0455 },
];
/** Lookup the Treasury yield matching the time-to-liquidity maturity (linear interpolation). */
export function lookupRiskFree(timeToLiquidityYears) {
    const t = Math.max(0, timeToLiquidityYears);
    if (t <= TREASURY_CURVE[0].maturity)
        return TREASURY_CURVE[0].yield;
    for (let i = 0; i < TREASURY_CURVE.length - 1; i++) {
        const a = TREASURY_CURVE[i];
        const b = TREASURY_CURVE[i + 1];
        if (t >= a.maturity && t <= b.maturity) {
            const frac = (t - a.maturity) / (b.maturity - a.maturity);
            return a.yield + frac * (b.yield - a.yield);
        }
    }
    return TREASURY_CURVE[TREASURY_CURVE.length - 1].yield;
}
export { TREASURY_CURVE };
//# sourceMappingURL=riskFreeLookup.js.map